import { mesaColorNames } from '@/src/common/theme'
import { View } from 'react-native'

export function HighnoteLayout({ children }: { children: React.ReactNode }) {
  return (
    <View
      style={{
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
      }}
    >
      {children}
    </View>
  )
}
